














































































































































































import BaseComponent from '@/core/base.component';
import { DeliveryFounderConsultContractDto } from '@/dto';
import Component from 'vue-class-component';
import BaseCard from '../../_components/BaseCard.vue';

import DeliveryFounderConsultContractService from '../../../services/delivery-founder-consult-contract.service';

@Component({
  name: 'DeliveryFounderConsultContractDetail',
  components: {
    BaseCard,
  },
})
export default class DeliveryFounderConsultContractDetail extends BaseComponent {
  private deliveryFounderConsultContractDto = new DeliveryFounderConsultContractDto();

  findOne() {
    DeliveryFounderConsultContractService.findOne(
      this.$route.params.id,
    ).subscribe(res => {
      if (res) {
        this.deliveryFounderConsultContractDto = res.data;
      }
    });
  }
  created() {
    this.findOne();
  }
}
